/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from "@reduxjs/toolkit";
import server from "api/server";
import { QuickSightDashboardResponse } from "../interfaces/quickSightDashboard.interface";

export const getQuickSightDashboardAction = createAsyncThunk<QuickSightDashboardResponse>("fetch-quicksight-dashboard", async () => {
  try {
    const { data } = await server.getQuickSightDashboard.loadDashboard();
    return data;
  } catch (error) {
    return console.error(error);
  }
});

export const createUSerSession = createAsyncThunk("create-dashboard-session-data", async (payload: any) => {
  try {
    const { data } = await server.getQuickSightDashboard.createUserSession(payload);
    return data;
  } catch (error) {
    return console.error(error);
  }
});
